/* ks-shipping-nav.js — 出貨方式導覽列的輪播
 *
 * 只做一件事：每隔 data-interval 毫秒換下一則 [data-ksn-slide]，順便同步頁點。
 * 沒有淡入淡出以外的動畫、沒有拖曳、沒有無限捲動 —— 這是導覽列不是輪播圖。
 */
(function () {
  'use strict';

  function initBar(el) {
    if (el.getAttribute('data-ksn-ready') === '1') return;
    el.setAttribute('data-ksn-ready', '1');

    var slides = el.querySelectorAll('[data-ksn-slide]');
    if (slides.length < 2) return;

    /* 桌機把兩則並排攤開了（見 CSS 的 min-width:750px），沒有要輪播的東西。
       判斷放在 tick 裡而不是只在啟動時，視窗跨過斷點才會即時反應。 */
    function isWide() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    var dots = el.querySelectorAll('[data-ksn-dots] i');
    var interval = parseInt(el.getAttribute('data-interval'), 10);
    if (!interval || interval < 1500) interval = 4500;

    var i = 0;
    var timer = null;

    function show(next) {
      slides[i].removeAttribute('data-on');
      if (dots[i]) dots[i].removeAttribute('data-on');
      i = next;
      slides[i].setAttribute('data-on', '1');
      if (dots[i]) dots[i].setAttribute('data-on', '1');
    }

    function start() {
      if (timer) return;
      timer = setInterval(function () {
        if (isWide()) return;
        show((i + 1) % slides.length);
      }, interval);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    /* 滑鼠停在上面或分頁切走時暫停 —— 客人正在讀的那一則不要換掉 */
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function boot(root) {
    var bars = (root || document).querySelectorAll('[data-ksn-bar]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  /* 佈景主題編輯器：拉進來或改設定後要重新綁 */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
